import type { AlertColor } from "@mui/material";
import { hr } from "@/constants/strings.hr";
import { USERNAME_PATTERN } from "@/constants/validation";

export function isValidUsername(username: string): boolean {
  return USERNAME_PATTERN.test(username);
}

export function notifyIfUsernameInvalid(
  username: string,
  notify: (message: string, severity?: AlertColor) => void,
): boolean {
  if (isValidUsername(username)) return true;
  notify(hr.errors.usernameRules, "error");
  return false;
}
